<!--
1. Make sure update works (esp. for all fields.)
2. Do we want to show profile completion % on sign up?
-->
<section forms class="py-5 px-7 sm:py-16 sm:px-20 mx-auto max-w-4xl">
  <div class="flex flex-col gap-3">
    <mat-card class="w-min" *ngIf="callerService.corpMember.Media?.url">
      <img
        mat-card-image
        [ngSrc]="callerService.corpMember.Media?.url!"
        width="56"
        height="56"
        alt="Your profile picture"
        class="object-cover max-w-14 h-auto"
      />
    </mat-card>
    <div class="flex items-center justify-between gap-2">
      <h5 class="text-2xl font-semibold">
        <ng-container *ngIf="callerService.corpMember.first_name; else noName">
          <a [routerLink]="['/p', callerService.corpMember.slug_id ?? callerService.corpMember.created_at]">Hi {{ callerService.corpMember.first_name }}</a>
        </ng-container>
        <ng-template #noName>
          <ng-container *ngIf="callerService.corpMember.state_code">
            {{ callerService.corpMember.state_code }}
          </ng-container>
        </ng-template>
      </h5>

      <!-- view public profile (only when profile is set to publicly visible) -->
      <button
        *ngIf="hasPublicProfile"
        type="button"
        mat-button
        color="primary"
        [routerLink]="['/p', callerService.corpMember.slug_id ?? callerService.corpMember.created_at]"
      >
        <span class="text-sm">View public profile</span>
        <!-- maybe use icon: open_in_new -->
        <mat-icon iconPositionEnd>arrow_outward</mat-icon>
      </button>
    </div>
  </div>

  <mat-card class="mt-5" *ngIf="callerService.corpMember.slug_id">
    <mat-card-header>
      <mat-card-subtitle>Invite others!</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>{{INVITE_TEXT}}</mat-card-content>
      <mat-card-actions align="end">
        <button type="button" mat-button color="primary" (click)="copyInviteText()">Copy message</button>
      </mat-card-actions>
  </mat-card>


  <mat-divider class="!mt-9 !mb-3"></mat-divider>
  <div class="flex flex-col pb-6">
    <h2 class="text-2xl">Service Details</h2>
    <!-- @todo: add checker to know if they've completed their profile -->
    <ng-container *ngIf="!callerService.corpMember.state_code">
      <p class="flex items-start gap-1 text-sm text-gray-600">
        <mat-icon inline>info</mat-icon> <span>Complete your service details to view posts</span>
      </p>
    </ng-container>
  </div>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="serviceDetailsFormGroup"
  >

    <div class="col-span-1 md:col-span-2" *ngIf="!callerService.corpMember.state_code">
      <mat-checkbox formControlName="signed_up_as_prospective_corp_member">
        <mat-label>I'm a Prospective Corp Member (without a state code)</mat-label>
      </mat-checkbox>
    <ng-container *ngIf="serviceDetailsFormGroup?.get(['signed_up_as_prospective_corp_member'])?.value">
      <br />
      <mat-hint class="text-xs">You'll have to fill in your state code once you're assgined one to have full access to the platform.</mat-hint>
    </ng-container>
    </div>
  
    <mat-form-field appearance="fill">
      <mat-label>Serving state</mat-label>

      <mat-select formControlName="service_state">
        <mat-option
          *ngFor="let option of ng_states"
          [value]="option.name"
          (onSelectionChange)="setSelectedStatesLGA($event, option)"
        >
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['service_state'])?.hasError('required')
        "
      >
        Serving state is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>State code</mat-label>
      <!-- @todo: disable from the .ts file -->
      <input
        title="State code"
        matInput
        formControlName="state_code"
        [disabled]="stateCodeInputDisabled"
      />
      <!--
              TODO: once you want to edit your state code, we'll ask you if you're sure!
              It'll show you a modal with a confirmation message. The default state of the state code input is disabled.
              Until then, leave this edit button commented.
            -->
      <!-- <button
                type="button"
                *ngIf="serviceDetailsFormGroup?.get(['state_code'])?.value"
                matSuffix
                mat-icon-button
                aria-label="Edit state code"
                (click)="toggleStateCodeInputDisabled()"
            >
                <mat-icon>edit</mat-icon>
            </button> -->
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['state_code'])?.hasError('required')
        "
      >
        State code is <strong>required</strong>
      </mat-error>
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['state_code'])?.hasError('pattern') &&
          !serviceDetailsFormGroup?.get(['state_code'])?.hasError('required')
        "
      >
        Please enter a valid state code
      </mat-error>
    </mat-form-field>


    <mat-form-field>
      <mat-label>LGA</mat-label>

      <mat-select formControlName="lga_id">
        <mat-option
          *ngFor="let option of selected_state_lgas"
          [value]="option.id"
        >
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="serviceDetailsFormGroup?.get(['lga_id'])?.hasError('required')"
      >
        LGA is <strong>required</strong>
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="fill">
      <mat-label>Stream</mat-label>
      <mat-select formControlName="stream">
        <mat-option *ngFor="let stream of serviceStreams" [value]="stream">
          {{ stream }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="serviceDetailsFormGroup?.get(['stream'])?.hasError('required')"
      >
        Stream is <strong>required</strong>
      </mat-error>
    </mat-form-field>


    <mat-form-field>
      <mat-label>City or Town</mat-label>
      <input title="City or Town" matInput formControlName="city_or_town" />
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['city_or_town'])?.hasError('required')
        "
      >
        City or Town is <strong>required</strong>
      </mat-error>
    </mat-form-field>

  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Personal Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="personalDetailsFormGroup"
  >
    <mat-form-field appearance="fill">
      <mat-label>First name</mat-label>
      <input formControlName="first_name" matInput [maxlength]="nameMaxLength" placeholder="Remi" />
      <mat-error
        *ngIf="
          personalDetailsFormGroup?.get(['first_name'])?.hasError('required')
        "
      >
        First name is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="personalDetailsFormGroup?.get(['first_name'])?.hasError('maxlength')">
        First name can be at most {{ nameMaxLength }} characters
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Last name</mat-label>
      <input formControlName="last_name" matInput [maxlength]="nameMaxLength" placeholder="Ikenna" />
      <mat-error
        *ngIf="
          personalDetailsFormGroup?.get(['last_name'])?.hasError('required')
        "
      >
        Last name is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="personalDetailsFormGroup?.get(['last_name'])?.hasError('maxlength')">
        Last name can be at most {{ nameMaxLength }} characters
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Do you have a nickname you go by?</mat-label>
      <input
        title="Nickname"
        matInput
        formControlName="nickname"
        placeholder="Obong"
      />
      <mat-hint
        >A nickname other corp members around you might know you by, or you'd
        want them to know you by.</mat-hint
      >
    </mat-form-field>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">PPA Details</h2>
  <div *ngIf="ppaRemoved" class="ppa-removed-notice mb-5" role="status">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>The PPA on your profile was removed by our team. Pick your PPA again below, or add it if it isn&apos;t listed.</span>
  </div>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="ppaDetailsFormGroup"
  >
    <mat-form-field>
      <mat-label>Name of PPA</mat-label>
      <input
        formControlName="ppa_name"
        matInput
        placeholder="St. Mary's Model Secondary School"
        [matAutocomplete]="autoPpaNames"
      />
      <button
        type="button"
        *ngIf="ppaDetailsFormGroup?.get(['ppa_name'])?.value"
        matSuffix
        mat-icon-button
        aria-label="Clear PPA name"
        (click)="ppaDetailsFormGroup.get('ppa_name')?.setValue(''); ppaDetailsFormGroup.get('ppa_id')?.setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        #autoPpaNames="matAutocomplete"
        [displayWith]="displayPpaName"
        (optionSelected)="ppaSelected($event)"
      >
        <mat-option
          *ngFor="let option of filteredLgaPPAs | async"
          id="{{ option.id }}"
          [value]="option.name"
          class="flex items-center justify-between"
        >
          <span>{{ option.name }}</span>
          <span *ngIf="option.corp_member_count > 0" class="text-xs text-gray-400 ml-2">
            {{ option.corp_member_count }} {{ option.corp_member_count === 1 ? 'corps member' : 'corps members' }} here
          </span>
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="!ppaDetailsFormGroup.get('ppa_name')?.value">
        This helps other corp members find it
      </mat-hint>
      <mat-hint
        *ngIf="ppaDetailsFormGroup.get('ppa_name')?.value && ppaDetailsFormGroup.get('ppa_id')?.value"
        class="text-green-700"
      >
        <span class="inline-flex items-center gap-1">
          <mat-icon>group</mat-icon>
          Joining an existing PPA — other corps members are already here
        </span>
      </mat-hint>
      <mat-hint
        *ngIf="ppaDetailsFormGroup.get('ppa_name')?.value && !ppaDetailsFormGroup.get('ppa_id')?.value"
        class="text-green-400"
      >
        <span class="inline-flex items-center gap-1">
          <mat-icon>add_circle_outline</mat-icon>
          New PPA — you'll be the first to add this
        </span>
      </mat-hint>

      <mat-error
        *ngIf="ppaDetailsFormGroup.get(['ppa_name'])?.hasError('required')"
      >
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Type of Institution</mat-label>
      <mat-hint>eg. School, Bank, Hospital, Gov. Institution — or type your own</mat-hint>
      <input
        title="Type of Institution"
        formControlName="type_of_institution"
        matInput
        [matAutocomplete]="autoTypeOfInstitution"
      />
      <button
        type="button"
        *ngIf="ppaDetailsFormGroup?.get(['type_of_institution'])?.value"
        matSuffix
        mat-icon-button
        aria-label="Clear PPA Type"
        (click)="ppaDetailsFormGroup.get('type_of_institution')?.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        autoActiveFirstOption
        #autoTypeOfInstitution="matAutocomplete"
      >
        <mat-option
          *ngFor="let option of filteredTypeOfInstitutionOptions | async"
          [value]="option"
        >
          {{ option }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          ppaDetailsFormGroup.get(['type_of_institution'])?.hasError('required')
        "
      >
        PPA Type is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="h-fit">
      <mat-label>PPA address</mat-label>
      <input
        formControlName="ppa_address"
        matInput
        placeholder="Opposite Ijukaya Estate, Favos, Umuahia"
      />
      <button
        type="button"
        matSuffix
        mat-icon-button
        [attr.aria-label]="isGettingLocation ? 'Getting location…' : 'Use my current location'"
        [disabled]="isGettingLocation"
        (click)="usePPAGeolocation()"
        matTooltip="Use my current location"
        matTooltipPosition="above"
      >
        <mat-icon *ngIf="!isGettingLocation">my_location</mat-icon>
        <mat-progress-spinner
          *ngIf="isGettingLocation"
          diameter="20"
          mode="indeterminate"
        ></mat-progress-spinner>
      </button>
      <mat-hint *ngIf="!ppaDetailsFormGroup.get('ppa_id')?.value && ppaDetailsFormGroup.get('ppa_address')?.value; else addressDefaultHint">
        Help future corps members find this — add a precise address
      </mat-hint>
      <ng-template #addressDefaultHint>
        <mat-hint>
          <span class="inline-flex items-center gap-1">Tip: click <mat-icon>my_location</mat-icon> to use your current location</span>
        </mat-hint>
      </ng-template>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Directions</mat-label>
      <textarea
        formControlName="ppa_directions"
        matInput
        placeholder="Please give directions to the PPA from a popular nearby junction or hard-to-miss building"
      ></textarea>
      <mat-hint *ngIf="!ppaDetailsFormGroup.get('ppa_id')?.value && ppaDetailsFormGroup.get('ppa_directions')?.value; else directionsDefaultHint">
        Help future corps members get here — add directions from a popular landmark
      </mat-hint>
      <ng-template #directionsDefaultHint>
        <mat-hint>Directions from a popular landmark (optional)</mat-hint>
      </ng-template>
    </mat-form-field>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Other Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="otherDetailsFormGroup"
  >
    <mat-form-field>
      <mat-label>Origin state</mat-label>
      <mat-select formControlName="travel_from_state">
        <mat-option *ngFor="let option of ng_states" [value]="option.name">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-hint>Optional. Where did you travel from for NYSC?</mat-hint>
      <mat-hint align="end" class="cursor-help">
        <mat-icon
          matTooltipPosition="above"
          matTooltip="So we can help pair corp members traveling together, or assist with transportation from our patners (ABC Transport, Jos Riders, etc.)"
          >info</mat-icon
        >
      </mat-hint>
      <!-- TODO: pull a dropdown of suggestions from other corp members from the backend. -->
    </mat-form-field>

    <mat-form-field>
      <mat-label>Origin city or town</mat-label>
      <mat-hint>Optional</mat-hint>
      <input
        title="Origin city or town"
        matInput
        formControlName="travel_from_city"
      />
    </mat-form-field>

    <!-- We don't really need to ask this question -->
    <!-- <mat-form-field class="h-fit">
            <mat-label>Where did you find accommodation?</mat-label>
            <input
                formControlName="where_they_found_accommodation"
                matInput
                placeholder="What part of town is it?"
            />
            <mat-hint
                >So corp members can know where other corp members
                are.</mat-hint
            >
        </mat-form-field> -->

    <div class="custom-radio-form-field">
      <!-- TODO: If they choose yes, we'll ask them what kind. -->
      <label>Want an SPA?</label>
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="want_spa_or_not"
      >
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
      <mat-hint class="mat-caption text-xs"
        >An SPA is a side job you do, if you have the time, during your Service
        Year for extra cash</mat-hint
      >
    </div>

    <!-- Too important a section to be in other details? -->
    <div class="custom-radio-form-field">
      <label>Looking for a roommate?</label>
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="looking_for_accommodation_or_not"
      >
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Bio</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="bioDetailsFormGroup"
  >
    <div class="custom-radio-form-field">
      <label>Public profile?</label>
      <!-- https://stackoverflow.com/a/57634824/9259701 -->
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="public_profile"
      >
        <mat-radio-button [value]="true">Publicly visible</mat-radio-button>
        <mat-radio-button [value]="false">Keep private</mat-radio-button>
      </mat-radio-group>
      <mat-hint class="mat-caption text-xs"
        >A publicly visible profile means you can
        <b>search for other corp members</b> and <b>be seen by them too</b>.
      </mat-hint>
    </div>

    <mat-form-field>
      <mat-label>Profile</mat-label>
      <!-- TODO: should we change the label from profile? to something better descriptive? -->
      <textarea
        matInput
        #profile
        maxlength="500"
        formControlName="bio"
        rows="5"
        placeholder="I'm a graphic designer. Get in touch if you like to travel. I'm your plug for all things phones. I'd love to visit Idanre hills before service year is over, who's in?"
      ></textarea>
      <mat-hint
        >What do you want other corp members to know about you?</mat-hint
      >
      <mat-hint align="end">{{ profile.value.length }} / 500</mat-hint>
    </mat-form-field>

    <div class="flex flex-col gap-2">
      <label for="profile_photo">Profile photo:</label>

      <mat-card
        class="w-min"
        *ngIf="selectedImage || callerService.corpMember.Media?.url"
      >
        <img
          mat-card-image
          [src]="selectedImage || callerService.corpMember.Media?.url"
          alt="Profile Picture"
          class="object-cover size-20"
          appImgSrcFallback
        />
      </mat-card>

      <!--
          File input design from https://tailwindcss.com/docs/hover-focus-and-other-states#file-input-buttons
          TODO: make it more like our feel.
      -->
      <input
        #profilePhotoInput
        title="Upload profile photo"
        accept="image/*"
        name="profile_photo"
        type="file"
        class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100 cursor-pointer"
        (change)="onFileSelected($event)"
      />
    </div>
  </form>

  <mat-divider class="!mt-9 !mb-6"></mat-divider>

  <!-- Always shown (even where push can't work) so someone who said "Not now" can find their way back. -->
  <section id="notifications" aria-labelledby="notifications-heading">
    <h2 id="notifications-heading" class="text-2xl pb-6">Notifications</h2>
    <div class="flex flex-col gap-2 pb-6">
      <mat-slide-toggle
        *ngIf="pushAvailability === 'available' || pushAvailability === 'blocked'"
        [checked]="pushAvailability === 'available' && (pushEnabled$ | async)"
        [disabled]="pushAvailability === 'blocked'"
        (change)="onPushToggleChange($event.checked)"
        aria-label="Enable push notifications on this device"
      >
        Enable push notifications on this device
      </mat-slide-toggle>
      <p *ngIf="pushUnavailableHelp" class="m-0 text-sm" role="status">{{ pushUnavailableHelp }}</p>
      <mat-hint class="mat-caption text-xs"
        >Get notified about new chat messages, referrals, and matching listings
        even when you're not on the site. Turn it on on each phone or computer you use.
        Without it, we'll email you when something on your wishlist is posted.</mat-hint
      >
    </div>

    <mat-divider class="!mt-9 !mb-3"></mat-divider>
  </section>

  <h2 class="text-2xl pb-6">Social Links</h2>

  <!-- Existing (saved) links -->
  <div *ngIf="externalLinks.length > 0" class="flex flex-col gap-2 mb-5">
    <ng-container *ngFor="let link of externalLinks">
      <!-- Edit mode -->
      <div
        *ngIf="editingLinkIds.has(link.id); else displayLink"
        [formGroup]="getLinkEditForm(link.id)"
        class="rounded-xl border border-[#1A433A] bg-gray-50 px-4 py-3"
      >
        <div class="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-3 mb-2">
          <mat-form-field>
            <mat-label>Label</mat-label>
            <input
              matInput
              formControlName="label"
              placeholder="e.g. LinkedIn"
              [matAutocomplete]="autoEditLinkLabel"
            />
            <mat-autocomplete autoActiveFirstOption #autoEditLinkLabel="matAutocomplete">
              <mat-option *ngFor="let opt of LINK_LABEL_OPTIONS" [value]="opt">{{ opt }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field>
            <mat-label>URL</mat-label>
            <input matInput formControlName="url" placeholder="https://..." type="url" inputmode="url" />
            <mat-error *ngIf="getLinkEditForm(link.id).get('url')?.hasError('pattern')">Must start with http:// or https://</mat-error>
          </mat-form-field>
        </div>

        <div class="flex justify-end gap-2">
          <button mat-button type="button" (click)="cancelEditLink(link.id)">Cancel</button>
          <button mat-flat-button color="primary" type="button" (click)="saveEditLink(link.id)">Save</button>
        </div>
      </div>

      <!-- Display mode -->
      <ng-template #displayLink>
        <div class="flex items-center justify-between gap-3 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50">
          <div class="flex items-center gap-2 min-w-0">
            <mat-icon class="text-[#1A433A] shrink-0">link</mat-icon>
            <div class="min-w-0">
              <p class="text-sm font-medium text-gray-800 truncate">{{ link.label }}</p>
              <a
                [href]="link.url"
                target="_blank"
                rel="noopener noreferrer"
                class="text-xs text-gray-400 hover:text-[#1A433A] truncate block"
              >{{ link.url }}</a>
            </div>
          </div>
          <div class="flex items-center shrink-0">
            <button
              mat-icon-button
              type="button"
              (click)="startEditLink(link)"
              aria-label="Edit link"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="deleteExternalLink(link.id)"
              aria-label="Remove link"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <p *ngIf="externalLinks.length === 0 && pendingLinksArray.length === 0" class="text-sm text-gray-400 mb-5">No links yet.</p>

  <!-- Pending (unsaved) link inputs -->
  <div *ngIf="pendingLinksArray.length > 0" class="flex flex-col gap-3 mb-5">
    <p class="text-xs text-gray-400">Will be saved when you click "Update details"</p>
    <div
      *ngFor="let group of pendingLinkGroups; let i = index"
      [formGroup]="group"
      class="relative rounded-xl border border-gray-200 bg-gray-50 px-4 pt-14 "
    >
      <!-- Remove button pinned to top-right of the card -->
      <button
        mat-icon-button
        type="button"
        (click)="removePendingLink(i)"
        aria-label="Remove link"
        class="!absolute top-1 right-1"
      >
        <mat-icon class="text-gray-400">close</mat-icon>
      </button>

      <div class="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-3">
        <mat-form-field>
          <mat-label>Label</mat-label>
          <input
            matInput
            formControlName="label"
            placeholder="e.g. LinkedIn"
            [matAutocomplete]="autoLinkLabel"
          />
          <mat-autocomplete autoActiveFirstOption #autoLinkLabel="matAutocomplete">
            <mat-option *ngFor="let opt of LINK_LABEL_OPTIONS" [value]="opt">{{ opt }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
          <mat-label>URL</mat-label>
          <input matInput formControlName="url" placeholder="https://..." type="url" inputmode="url" />
          <mat-error *ngIf="group.get('url')?.hasError('pattern')">Must start with http:// or https://</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Add link button -->
  <div class="mb-4">
    <button mat-stroked-button type="button" (click)="addExternalLink()">
      <mat-icon>add</mat-icon>
      Add link
    </button>
  </div>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <!-- prev. (click)="updateCorpMemberProfile()" after that updateEverything() -->
  <app-progress-button
    buttonClass="width-fit !min-w-9"
    (click)="updateProfile()"
    buttonText="Update details"
    [loading]="isUpdatingProfile"
    [disabled]="isUpdatingProfile"
  ></app-progress-button>
</section>
